import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { FORM_KEYS } from "../../../../../../../constants";

/**
 * @desc Schema for Orders form.
 */
const schema = yup.object({
  [FORM_KEYS.PRODUCT_IS_SOLD_OUT]: yup.boolean(),
  [FORM_KEYS.PRODUCT_NAME]: yup.string(),
  [FORM_KEYS.PRODUCT_EYEBROW]: yup.string(),
  [FORM_KEYS.PRODUCT_LICENSE]: yup.string(),
  [FORM_KEYS.PRODUCT_FOOTER]: yup.string(),
  [FORM_KEYS.PRODUCT_NUMBER]: yup.string(),
  [FORM_KEYS.PRODUCT_INDEX]: yup.string(),
  [FORM_KEYS.PRODUCT_PRICE]: yup.string(),
  [FORM_KEYS.PRODUCT_IMAGE]: yup.string(),
  [FORM_KEYS.PRODUCT_SKU]: yup.string(),
});

/**
 * @desc Hook for validating login form.
 */
export const useProductDetailsForm = (defaultValues = {}) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues,
  });
};
